import React, { useState, useEffect } from "react";
import API from "../api/axiosInstance";
import { AutomationExecution } from "../types/interfaces";

const AutomationMonitoring: React.FC = () => {
    const [executions, setExecutions] = useState<AutomationExecution[]>([]);

    useEffect(() => {
        //API.get("/automation-executions").then((res) => setExecutions(res.data));
    }, []);

    return (
        <div>
            <h3>Automation Monitoring</h3>
            <table>
                <thead>
                    <tr>
                        <th>Automation</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Status</th>
                        <th>Priority</th>
                        <th>Retries</th>
                    </tr>
                </thead>
                <tbody>
                    {executions.map((exec) => (
                        <tr key={exec.logID}>
                            <td>{exec.automation.name}</td>
                            <td>{new Date(exec.startTime).toLocaleString()}</td>
                            <td>{exec.endTime ? new Date(exec.endTime).toLocaleString() : "Running..."}</td>
                            <td>{exec.status}</td>
                            <td>{exec.automation.priority === 1 ? "High" : exec.automation.priority === 2 ? "Normal" : "Low"}</td>
                            <td>{exec.automation.currentRetries} / {exec.automation.maxRetries}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AutomationMonitoring;
